import React, { Dispatch } from 'react'
import axios from 'ps-components/lib/apiClient';
import { Card, LoadingOverlay, Stack, Tabs, Text, Title, UnstyledButton } from "@mantine/core"
import { ReportInspectorAction, ReportInspectorState } from '../store'
import { useQuery } from 'react-query';
import { FormulaReports } from './FormulaReports';
import { Detail } from '../Detail';

type FormulaDetailsProps = {
    state: ReportInspectorState
    dispatch: Dispatch<ReportInspectorAction>
}

export const FormulaDetails = ({ state, dispatch }: FormulaDetailsProps) => {
    const { selectedFormulaPk, formulasActiveTab, formulaReportsPage } = state

    const getFormulaReports = async () => {
        try {
            const response = await axios.apiGet(`/api/marketpay-internal/report-inspector/formulaReports?formulaPk=${selectedFormulaPk}&page=${formulaReportsPage}&limit=50`)
            const { reports, formula } = response.data
            return { reports: reports || [], details: formula || null }
        } catch (error) {
            console.error(`Error getting formula reports: ${error}`)
            return { reports: [], details: null }
        }
    }

    const { data: formula, isLoading, isPreviousData } = useQuery(['formulaReports', { formulaPk: selectedFormulaPk, page: formulaReportsPage }], getFormulaReports, { enabled: !!selectedFormulaPk, keepPreviousData: true })

    const isActiveTab = (tab: string) => tab === formulasActiveTab ? 'bold' : 'normal'

    return (
        <Stack>
            <LoadingOverlay visible={isLoading || isPreviousData} />
            <Card>
                <UnstyledButton mb='10px' onClick={() => dispatch({ type: 'setSelectedFormulaPk', payload: undefined })}>
                    <Text size='lg' c='blue'>Return to list</Text>
                </UnstyledButton>
                <Title order={4}>{formula?.details?.formula_name}</Title>
            </Card>
            <Tabs variant="outline" value={formulasActiveTab} onChange={payload => dispatch({ type: 'setFormulasActiveTab', payload })}>
                <Tabs.List>
                    <Tabs.Tab value="details"><Text size='lg' fw={isActiveTab('details')} c='blue'>Details</Text></Tabs.Tab>
                    <Tabs.Tab value="reports"><Text size='lg' fw={isActiveTab('reports')} c='blue'>Reports</Text></Tabs.Tab>
                </Tabs.List>

                <Tabs.Panel value="details" pt="xs">
                    <Stack m='xl'>
                        <Detail label='Formula PK' value={formula?.details?.formula_pk} />
                        <Detail label='Old Template Formula PK' value={formula?.details?.old_template_formula_pk} />
                        <Detail label='Created On' value={formula?.details?.created_time} />
                        <Detail label='Creator User ID' value={formula?.details?.creator_user_id} />
                        <Detail label='Last Modifying User ID' value={formula?.details?.last_modifying_user_id} />
                        <Detail label='Organization ID' value={formula?.details?.organization_id} />
                        <Detail label='Last Modified' value={formula?.details?.last_modified_time} />
                        <Detail label='Description' value={formula?.details?.formula_description} />
                        <Detail label='Field Table Agg' value={formula?.details?.field_table_agg} />
                        <Detail label='Nullify Zero' value={formula?.details?.formula_nullify_zero} />
                        <Detail label='Weight By' value={formula?.details?.weight_by} />
                        <Detail label='Store Agg in UDF' value={formula?.details?.formula_store_agg_in_udf} />
                        <Detail label='Summary Element PKs' value={formula?.details?.formula_summary_elem_pks} />
                        <Detail label='Preview' value={formula?.details?.formula_preview} />
                        <Detail label='Formula Clause' value={formula?.details?.formula_clause} code />
                        <Detail label='Metadata' value={formula?.details?.metadata} code />
                    </Stack>
                </Tabs.Panel>
                <Tabs.Panel value="reports" pt="xs">
                    <FormulaReports page={formulaReportsPage} reports={formula?.reports} dispatch={dispatch} lastModified={formula?.details?.last_modified_time} />
                </Tabs.Panel>
            </Tabs>
        </Stack>
    )
}